var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22H5C4.45 22 4 21.55 4 21V12H20V21C20 21.55 19.55 22 19 22Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12H3C2.45 12 2 11.55 2 11V9C2 8.45 2.45 8 3 8H21C21.55 8 22 8.45 22 9V11C22 11.55 21.55 12 21 12Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.00001C13.81 7.99001 15.23 7.64001 16.13 7.34001C17.29 6.96001 18.28 6.47001 19.11 5.70001C19.5 5.34001 19.83 4.92001 19.95 4.43001C20.08 3.88001 19.92 3.29001 19.55 2.85001C19.18 2.41001 18.62 2.12001 18.02 2.03001C17.54 1.96001 17.03 2.01001 16.61 2.24001C16.25 2.44001 15.97 2.75001 15.75 3.08001C15.28 3.79001 15.06 4.60001 14.66 5.34001C14.12 6.34001 13.31 6.98001 12.87 7.34001C12.54 7.63001 12.23 7.85001 12 8.00001Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.00001C10.1902 7.99001 8.77021 7.64001 7.87021 7.34001C6.71021 6.97001 5.71021 6.47001 4.89021 5.71001C4.50021 5.35001 4.16021 4.93001 4.05021 4.44001C3.91021 3.89001 4.07021 3.30001 4.44021 2.85001C4.81021 2.41001 5.37021 2.12001 5.97021 2.03001C6.45021 1.96001 6.96021 2.01001 7.38021 2.24001C7.74021 2.44001 8.02021 2.75001 8.24021 3.08001C8.71021 3.79001 8.93021 4.60001 9.33021 5.34001C9.87021 6.34001 10.6802 6.98001 11.1202 7.34001C11.4602 7.63001 11.7702 7.85001 12.0002 8.00001Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V22",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C12.28 7 12.5 7.22 12.5 7.5V8H11.5V7.5C11.5 7.22 11.72 7 12 7Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.6e1922748b65e326cd769f5e38441919.svg";
export { ForwardRef as ReactComponent };